module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_7042.8990d8d8.png";